/* eslint-disable no-underscore-dangle, react/destructuring-assignment */
import React from "react";
import __ from "src/utils/Translations";

export const periodOptions = [
  { value: "P1M", label: "Co miesiąc" },
  { value: "P2M", label: "Co 2 miesiące" },
  { value: "P3M", label: "Co 3 miesiące" },
  { value: "P4M", label: "Co 4 miesiące" },
  { value: "P6M", label: "Co 6 miesięcy" },
  { value: "P12M", label: "Co 12 miesięcy" },
];

export const statuses = [
  { value: "CREATED", label: "Stworzono" },
  { value: "PREPARING_CALCULATORS", label: "Przygotowywanie kalkulatorów" },
  { value: "WAITING_FOR_CALCULATORS", label: "Oczekiwanie na kalkulatory" },
  {
    value: "WAITING_FOR_CHARGE_TIME",
    label: "Oczekiwanie na datę doładowania",
  },
  { value: "PREPARING_TRANSFERS", label: "Przygotowywanie transferów" },
  { value: "WAITING_FOR_TRANSFERS", label: "Oczekiwanie na transfery" },
  { value: "CANCELED", label: "Anulowano" },
];
const PERIODICITY_MONTHLY = "MONTHLY";
const PERIODICITY_EVERY_TWO_MONTHS = "EVERY_TWO_MONTHS";
const PERIODICITY_EVERY_THREE_MONTHS = "EVERY_THREE_MONTHS";
const PERIODICITY_EVERY_FOUR_MONTHS = "EVERY_FOUR_MONTHS";
const PERIODICITY_EVERY_SIX_MONTHS = "EVERY_SIX_MONTHS";
const PERIODICITY_ANNUALLY = "ANNUALLY";
export const periodicityOptions = [
  { value: PERIODICITY_MONTHLY, label: "Co miesiąc" },
  { value: PERIODICITY_EVERY_TWO_MONTHS, label: "Co dwa miesiące" },
  { value: PERIODICITY_EVERY_THREE_MONTHS, label: "Co trzy miesiące" },
  { value: PERIODICITY_EVERY_FOUR_MONTHS, label: "Co cztery miesiące" },
  { value: PERIODICITY_EVERY_SIX_MONTHS, label: "Co pół roku" },
  { value: PERIODICITY_ANNUALLY, label: "Raz do roku" },
];
const monthsPeriodicityMap = {
  [PERIODICITY_MONTHLY]: 1,
  [PERIODICITY_EVERY_TWO_MONTHS]: 2,
  [PERIODICITY_EVERY_THREE_MONTHS]: 3,
  [PERIODICITY_EVERY_FOUR_MONTHS]: 4,
  [PERIODICITY_EVERY_SIX_MONTHS]: 6,
  [PERIODICITY_ANNUALLY]: 12,
};

const months = [
  "Styczeń",
  "Luty",
  "Marzec",
  "Kwiecień",
  "Maj",
  "Czerwiec",
  "Lipiec",
  "Sierpień",
  "Wrzesień",
  "Październik",
  "Listopad",
  "Grudzień",
];
export const MonthsCell = (cellInfo) => {
  const { periodicity, executionStartMonth = "" } = cellInfo.row._original;
  const month = +executionStartMonth.split("-")[1] || null;
  if (!month) {
    return null;
  }
  const monthsToDisplay = [];
  const frequency = monthsPeriodicityMap[periodicity];
  if (!frequency) {
    return null;
  }
  for (let i = month - 12; i <= 12; i += frequency) {
    if (i >= 0 && months[i - 1]) {
      monthsToDisplay.push(__(months[i - 1]));
    }
  }
  return (
    <div className="d-block w-100 text-center">
      {monthsToDisplay.join(", ")}
    </div>
  );
};
